import { FileSpreadsheet, Upload } from 'lucide-react';
import { Alert } from '@/components/ui';
import type { ImportStatus } from '../../hooks/useShadeLibrary';

interface ShadeLibraryBannerProps {
  shadeCount: number;
  status: ImportStatus;
  onImport: (file: File) => void;
}

export function ShadeLibraryBanner({ shadeCount, status, onImport }: ShadeLibraryBannerProps) {
  return (
    <div className="p-3.5 bg-gradient-to-r from-blue-50/80 to-indigo-50/50 rounded-xl border border-blue-200/80 space-y-2">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
        <div>
          <p className="text-xs font-bold text-blue-950 flex items-center gap-1.5">
            <FileSpreadsheet className="w-4 h-4 text-blue-600" />
            Colour Creation Palette II (Shade Code Database)
          </p>
          <p className="text-[10px] text-blue-700/80 font-medium">
            Saved {shadeCount} Asian Paints NP shade codes. Use search bars below for Primary Wall, Trim & Feature
            Highlight.
          </p>
        </div>

        <label
          htmlFor="excel-palette-upload"
          className="cursor-pointer bg-blue-600 hover:bg-blue-700 text-white text-[11px] font-bold px-3 py-1.5 rounded-lg flex items-center gap-1.5 shadow-xs transition-colors flex-shrink-0"
        >
          <Upload className="w-3.5 h-3.5" />
          Upload Additional .xlsx
        </label>
        <input
          type="file"
          id="excel-palette-upload"
          accept=".xlsx,.xls,.csv"
          className="hidden"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) onImport(file);
            e.target.value = ''; // allow re-importing the same file
          }}
        />
      </div>

      {status && (
        <Alert tone={status.tone} className="text-[11px] font-medium p-2 rounded-lg">
          {status.message}
        </Alert>
      )}
    </div>
  );
}
